import axios from 'axios'
import { ICrudDeleteAction, ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudSearchAction } from 'react-jhipster'

import { cleanEntity } from '../../../../utils/entity-utils'
import { FAILURE, REQUEST, SUCCESS } from '../../action-type.util'

import { defaultValue, IBilliardTableExtended } from '../../../model/extended/billiard-table-extended.model'

export const ACTION_TYPES = {
  SEARCH_BILLIARDTABLES: 'billiardTableExtended/SEARCH_BILLIARDTABLES',
  FETCH_BILLIARDTABLE_LIST: 'billiardTableExtended/FETCH_BILLIARDTABLE_LIST',
  FETCH_BILLIARDTABLE: 'billiardTableExtended/FETCH_BILLIARDTABLE',
  CREATE_BILLIARDTABLE: 'billiardTableExtended/CREATE_BILLIARDTABLE',
  UPDATE_BILLIARDTABLE: 'billiardTableExtended/UPDATE_BILLIARDTABLE',
  DELETE_BILLIARDTABLE: 'billiardTableExtended/DELETE_BILLIARDTABLE',
  RESET: 'billiardTableExtended/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IBilliardTableExtended>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

export type BilliardTableExtendedState = Readonly<typeof initialState>;

// Reducer

export default (state: BilliardTableExtendedState = initialState, action): BilliardTableExtendedState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.SEARCH_BILLIARDTABLES):
    case REQUEST(ACTION_TYPES.FETCH_BILLIARDTABLE_LIST):
    case REQUEST(ACTION_TYPES.FETCH_BILLIARDTABLE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_BILLIARDTABLE):
    case REQUEST(ACTION_TYPES.UPDATE_BILLIARDTABLE):
    case REQUEST(ACTION_TYPES.DELETE_BILLIARDTABLE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.SEARCH_BILLIARDTABLES):
    case FAILURE(ACTION_TYPES.FETCH_BILLIARDTABLE_LIST):
    case FAILURE(ACTION_TYPES.FETCH_BILLIARDTABLE):
    case FAILURE(ACTION_TYPES.CREATE_BILLIARDTABLE):
    case FAILURE(ACTION_TYPES.UPDATE_BILLIARDTABLE):
    case FAILURE(ACTION_TYPES.DELETE_BILLIARDTABLE):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.SEARCH_BILLIARDTABLES):
    case SUCCESS(ACTION_TYPES.FETCH_BILLIARDTABLE_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      };
    case SUCCESS(ACTION_TYPES.FETCH_BILLIARDTABLE):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_BILLIARDTABLE):
    case SUCCESS(ACTION_TYPES.UPDATE_BILLIARDTABLE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_BILLIARDTABLE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/billiard-tables';
const apiSearchUrl = 'api/_search/billiard-tables';

// Actions

export const getSearchEntities: ICrudSearchAction<IBilliardTableExtended> = (query, page, size, sort) => ({
  type: ACTION_TYPES.SEARCH_BILLIARDTABLES,
  payload: axios.get<IBilliardTableExtended>(`${apiSearchUrl}?query=${query}${sort ? `&page=${page}&size=${size}&sort=${sort}` : ''}`),
});

export const getEntities: ICrudGetAllAction<IBilliardTableExtended> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_BILLIARDTABLE_LIST,
    payload: axios.get<IBilliardTableExtended>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  };
};

export const getEntity: ICrudGetAction<IBilliardTableExtended> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_BILLIARDTABLE,
    payload: axios.get<IBilliardTableExtended>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IBilliardTableExtended> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_BILLIARDTABLE,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IBilliardTableExtended> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_BILLIARDTABLE,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IBilliardTableExtended> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_BILLIARDTABLE,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});

export const getActiveEntities: ICrudGetAllAction<IBilliardTableExtended> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=eventId&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_BILLIARDTABLE_LIST,
    payload: axios.get<IBilliardTableExtended>(`${requestUrl}${sort ? '&' : '?'}activeTables=true&cacheBuster=${new Date().getTime()}`),
  };
};
